import type { CommandData, ShowMessageCommandData } from '../types'

export function showPreviewMessage(proactiveMessage?: ShowMessageCommandData['message']) {
  const message: CommandData = {
    isFromNetwatch: true,
    command: 'showPreviewMessage',
    message: proactiveMessage,
  }
  window.postMessage(message)
}
